module.exports = __webpack_public_path__ + "static/img/bg1.390c6b42.png";